export default __webpack_public_path__ + "static/media/wallet-grey.94a4f57b.svg";